import { Box, Typography } from "@husqvarna/ui-core";
import "./PageContainer.scss";

export type PageContainerProps = {
  headline: string;
  description: string;
  headlineAction?: React.ReactNode | React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
  noDivider?: boolean;
};

const PageContainer = ({
  headline,
  description,
  headlineAction,
  children,
  noDivider = false,
}: PageContainerProps) => {
  return (
    <Box br={5} backgroundColor="White" px={8} py={10} className="tcsp-content">
      <Box
        flexDirection="row"
        alignContent="center"
        justifyContent="space-between"
        mb={6}
      >
        <Typography tag="h1" variant="Heading4" text={headline} />
        {headlineAction}
      </Box>
      <Typography
        variant="Body2"
        text={description}
        mb={noDivider ? 0 : 12}
        className="page-description"
      />
      {!noDivider && <hr />}
      <Box mt={12}>{children}</Box>
    </Box>
  );
};

export default PageContainer;
